module.exports = __webpack_public_path__ + "assets/images/project/map-logo.jpg?v=ea1f19fe";